import type { SVGProps } from 'react'
const SvgSyChainlink = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" width={24} height={24} {...props}>
		<path d="m500 6.8-90.5 52-246.6 142.6-90.5 52v493.2l90.5 52 248.8 142.5 90.5 52 90.5-52L837 798.6l90.5-52V253.4l-90.5-52L590.5 58.9zM253.4 642.5v-285L500 215l246.6 142.5v285L500 785z" />
	</svg>
)
export default SvgSyChainlink
